export var EffectType = {
  WordArt: 1,
  Sticker: 2,
  AudioEffect: 3,
  Music: 4,
  Video: 5,
  TextTemplate: 6,
  Special: 7,
  FaceSpecial: 8,
  Image: 9,
  Formula: 50,
  WordArtCollection: 101,
  StickerCollection: 102,
  AudioEffectCollection: 103,
  VideoCollection: 104,
  Emoticon: 105,
  TextTemplateCollection: 106,
  Filter: 12,
  FilterCollection: 112
};